<div class="logged-in-view h-full overflow-y-auto">
    <div class="w-full flex flex-col md:flex-row justify-between mb-8 gap-4">
        <div class="flex flex-col gap-4">
            <h1 class="text-app-primary-10">Meine Rezepte</h1>
        </div>
    </div>

    <mat-tab-group class="mt-8 w-full" [mat-align-tabs]="'left'" [mat-stretch-tabs]="false">
        <!-- Tab: Aktuelle Rezepte -->
        <mat-tab label="Aktuelle Rezepte">
            <div class="pt-6">
                <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
                    @for (patRecipe of upcomingRecipes; track patRecipe.id) {
                        <div class="bg-white rounded-xl shadow-sm border border-app-primary-10/10 overflow-hidden flex flex-col">
                            <!-- Card Header -->
                            <div class="p-5 border-b border-app-primary-10/5 bg-app-background-20/30">
                                <div class="flex justify-between items-start mb-2">
                                    <div class="flex flex-col">
                                        @if (patRecipe.isReadyForReview) {
                                            <span class="text-xs text-app-secondary-10 font-medium uppercase tracking-wider">Folgerezept beantragt</span>
                                            <span class="text-app-primary-10 font-bold">{{ patRecipe.issueDate | date: 'dd.MM.yyyy' }}</span>
                                        } @else {
                                            <span class="text-xs text-app-secondary-10 font-medium uppercase tracking-wider">Ausgestellt am</span>
                                            <span class="text-app-primary-10 font-bold">{{ patRecipe.issueDate | date: 'dd.MM.yyyy' }}</span>
                                        }
                                    </div>
                                    <div class="flex flex-col items-end">
                                        <span class="text-xs text-app-secondary-10 font-medium uppercase tracking-wider">Status</span>
                                        @if (patRecipe.paymentInfos) {

                                            <div [ngClass]="{
                                            'text-green-600': patRecipe.paymentInfos.paymentState === 'paid/finalized',
                                            'text-app-secondary-10': patRecipe.paymentInfos.paymentState === 'pending',
                                            'text-red-500': patRecipe.paymentInfos.paymentState === 'voided'
                                        }" class="font-semibold text-sm">
                                                @if (patRecipe.paymentInfos && !patRecipe.isEditableByPatient) {
                                                    @switch (patRecipe.paymentInfos.paymentState) {
                                                        @case ('paid/finalized') {
                                                            Bezahlt
                                                        }
                                                        @case ('pending') {
                                                            Bezahlung ausstehend
                                                        }
                                                        @case ('voided') {
                                                            Storniert
                                                        }
                                                        @default {
                                                            Status unbekannt
                                                        }
                                                    }
                                                } @else if (!patRecipe.paymentInfos && !patRecipe.isEditableByPatient && !patRecipe.isReadyForReview) {
                                                    @switch (patRecipe.state) {
                                                        @case ('draft') {
                                                            Rezept in der Erstellung
                                                        }
                                                        @case ('published') {
                                                            Rezept wurde erstellt
                                                        }
                                                        @default {
                                                            Status unbekannt
                                                        }
                                                    }
                                                } @else if (patRecipe.isReadyForReview) {
                                                    Rezept wird vom Arzt geprüft
                                                }
                                            </div>
                                        } @else {
                                            <span class="text-app-secondary-10 font-semibold text-sm">Rezept in Bearbeitung</span>
                                        }
                                    </div>
                                </div>
                                <div class="text-sm">
                                    <span class="text-app-secondary-10">Arzt: </span>
                                    <span class="font-medium text-app-primary-10">
                                        {{patRecipe.doctor.title ? patRecipe.doctor.title + ' ' : ''}}{{patRecipe.doctor.firstName}} {{patRecipe.doctor.lastName}}
                                    </span>
                                </div>
                            </div>

                            <!-- Card Content -->
                            <div class="p-5 flex-1 space-y-4">
                                <div class="space-y-3">
                                    @for (position of patRecipe.positions; track position.articleNumber) {
                                        <div class="flex justify-between items-start gap-4">
                                            <div class="flex flex-col">
                                                <span class="text-sm font-medium text-app-primary-10">{{ position.articleName }}</span>
                                                <span class="text-xs text-app-secondary-10">#{{ position.articleNumber }}</span>
                                            </div>
                                            <span class="text-xs font-semibold bg-app-background-20 px-2 py-1 rounded shrink-0">
                                                {{ position.quantity }} x {{position.bindingSize}}
                                            </span>
                                        </div>
                                    }
                                </div>
                            </div>

                            <!-- Card Footer Actions -->
                            <div class="p-5 bg-app-background-20/30 border-t border-app-primary-10/5 flex flex-wrap gap-2 mt-auto">
                                @if (patRecipe.paymentInfos && patRecipe.paymentInfos.paymentState == 'pending') {
                                    <button class="btn secondary-button text-xs py-2 h-auto flex-1" (click)="navigateToPortal(patRecipe)">Zur Bezahlseite</button>
                                }
                                @if (patRecipe.isEditableByPatient) {
                                    <button class="btn primary-button text-xs py-2 h-auto flex-1 disabled:opacity-50 disabled:cursor-not-allowed"
                                            [disabled]="isLoadingFollowRecipe"
                                            (click)="routeToFollowRecipe(patRecipe, false)">
                                        @if (isLoadingFollowRecipe) {
                                            <i class="fa-solid fa-spinner fa-spin mr-2"></i>
                                        }
                                        Folgerezept beantragen
                                    </button>
                                }
                            </div>
                        </div>
                    } @empty {
                        <div class="col-span-full py-12 flex flex-col items-center justify-center text-app-secondary-10 bg-app-background-20/50 rounded-xl border border-dashed border-app-primary-10/20">
                            <i class="fa-solid fa-receipt text-4xl mb-3 opacity-20"></i>
                            <p class="text-center">Keine aktuellen Rezepte gefunden.</p>
                        </div>
                    }
                </div>
            </div>
        </mat-tab>

        <!-- Tab: Vergangene Rezepte -->
        <mat-tab label="Vergangene Rezepte">
            <div class="pt-6">
                <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
                    @for (patRecipe of pastRecipes; track patRecipe.id) {
                        <div class="bg-white rounded-xl shadow-sm border border-app-primary-10/10 overflow-hidden flex flex-col opacity-90 grayscale-[0.3]">
                             <!-- Card Header -->
                             <div class="p-5 border-b border-app-primary-10/5 bg-app-background-20/30">
                                <div class="flex justify-between items-start mb-2">
                                    <div class="flex flex-col">
                                        <span class="text-xs text-app-secondary-10 font-medium uppercase tracking-wider">Ausgestellt am</span>
                                        <span class="text-app-primary-10 font-bold">{{ patRecipe.issueDate | date: 'dd.MM.yyyy' }}</span>
                                    </div>
                                    <div class="flex flex-col items-end">
                                        <span class="text-xs text-app-secondary-10 font-medium uppercase tracking-wider">Status</span>
                                        <span class="text-app-secondary-10 font-semibold text-sm">Vergangen</span>
                                    </div>
                                </div>
                                <div class="text-sm">
                                    <span class="text-app-secondary-10">Arzt: </span>
                                    <span class="font-medium text-app-primary-10">
                                        {{patRecipe.doctor.title ? patRecipe.doctor.title + ' ' : ''}}{{patRecipe.doctor.firstName}} {{patRecipe.doctor.lastName}}
                                    </span>
                                </div>
                            </div>

                            <!-- Card Content -->
                            <div class="p-5 flex-1 space-y-4">
                                <div class="space-y-3">
                                    @for (position of patRecipe.positions; track position.articleNumber) {
                                        <div class="flex justify-between items-start gap-4">
                                            <div class="flex flex-col">
                                                <span class="text-sm font-medium text-app-primary-10">{{ position.articleName }}</span>
                                                <span class="text-xs text-app-secondary-10">#{{ position.articleNumber }}</span>
                                            </div>
                                            <span class="text-xs font-semibold bg-app-background-20 px-2 py-1 rounded shrink-0">
                                                {{ position.quantity }} x {{position.bindingSize}}
                                            </span>
                                        </div>
                                    }
                                </div>
                            </div>

                            <!-- Card Footer Actions -->
                            <div class="p-5 bg-app-background-20/30 border-t border-app-primary-10/5 flex flex-wrap gap-2 mt-auto">
                                @if (patRecipe.state !== 'draft') {
                                    <button class="btn primary-button text-xs py-2 h-auto flex-1 disabled:opacity-50 disabled:cursor-not-allowed"
                                            [disabled]="isLoadingFollowRecipe"
                                            (click)="routeToFollowRecipe(patRecipe)">
                                        @if (isLoadingFollowRecipe) {
                                            <i class="fa-solid fa-spinner fa-spin mr-2"></i>
                                        }
                                        Folgerezept anfragen
                                    </button>
                                }
                            </div>
                        </div>
                    } @empty {
                        <div class="col-span-full py-12 flex flex-col items-center justify-center text-app-secondary-10 bg-app-background-20/50 rounded-xl border border-dashed border-app-primary-10/20">
                            <i class="fa-solid fa-receipt text-4xl mb-3 opacity-20"></i>
                            <p class="text-center">Keine vergangenen Rezepte gefunden.</p>
                        </div>
                    }
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>
